module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"scopeComparingError":"Kapsam verisi bulunamadı","changingColumn":"Değişim (%)","scopeBarChartTitle":"Kapsam Kıyaslaması"},"en":{"scopeComparingError":"No scope data","changingColumn":"Change (%)","scopeBarChartTitle":"Scope Comparison"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Analysis/Tabs/components/ScopeComparison.vue
// module id = m+c3
// module chunks = 1